import React from 'react';
import './PageHeader.scss';

interface IProps {
  value: string;
  stepCurrent?: number;
  stepTotal?: number;
  renderStepInfo?: (stepCurrent: number, stepTotal: number) => string;
}

const PageHeader = ({
  value,
  stepCurrent,
  stepTotal,
  renderStepInfo
}: IProps) => {
  return (
    <React.Fragment>
      <h1 className={'h1'}>
        {value}
        {stepCurrent !== undefined && stepTotal !== undefined && (
          <span className={'step'}>
            {!renderStepInfo
              ? `Steg ${stepCurrent} av ${stepTotal}`
              : renderStepInfo(stepCurrent, stepTotal)}
          </span>
        )}
      </h1>
    </React.Fragment>
  );
};

export { PageHeader };
